// extracted by mini-css-extract-plugin
module.exports = {"Container":"Chat_Container__1KhD4","ChatRow":"Chat_ChatRow__3VPAG","Sender":"Chat_Sender__1iUPA","Reciver":"Chat_Reciver__23X5W","LightRight":"Chat_LightRight__2ZXsW"};